import React, { useState, useRef, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { preventDefault } from '~/__modules__/browser';

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  directionTop: PropTypes.bool,
  appendix: PropTypes.node,
};
export default function Tooltip({ children, directionTop = false, appendix }) {
  const { t } = useTranslation();

  const [opened, setOpened] = useState(false);
  const handleClick = () => setOpened((opened) => !opened);
  const close = () => setOpened(false);

  const elemRef = useRef();
  useEffect(() => {
    if (!opened) return;

    const { body } = document;
    const onClickBody = ({ target }) => {
      if (elemRef.current.contains(target)) return;
      close();
    };
    body.addEventListener('click', onClickBody);
    return () => body.removeEventListener('click', onClickBody);
  }, [opened]);

  return (
    <div ref={elemRef} className="tooltip_cover">
      <a
        href="#"
        className={classNames('ico_help', { on: opened })}
        onClick={preventDefault(handleClick)}
      >
        <i className="blind">{t('button_help')}</i>
      </a>
      {opened && (
        <div
          className={classNames('ly_tooltip', { direction_top: directionTop })}
        >
          {children}
          {!_.isEmpty(appendix) && appendix}
          <button type="button" className="btn_tooltip_close" onClick={close}>
            <i className="blind">{t('button_close')}</i>
          </button>
        </div>
      )}
    </div>
  );
}
